import { useEffect, useRef, useState } from 'react'

import { conteggioGruppo, environmentDelloScenario, gruppoApertoDiDefault } from './Functions'
import { Icona } from './Icon'
import { VoceScenario } from './ScenarioItem'

/**
 * Un gruppo del catalogo (ambito, decisioni, flusso…): intestazione con chevron, casella di
 * gruppo (parziale se solo alcuni sono scelti) e «scelti/totali»; il corpo è una griglia di
 * righe dense. Parte chiuso, salvo selezioni o ricerca in corso; quando parte una ricerca
 * si apre da solo.
 * @param {Object} props - Proprietà
 * @param {string} props.nome - Nome del gruppo
 * @param {Array<Object>} props.scenari - Gli scenari del gruppo (già filtrati)
 * @param {string[]} props.selezionati - La selezione del form
 * @param {string} props.ricerca - Il testo cercato nel catalogo
 * @param {(ids: string[], acceso: boolean) => void} props.onCommuta - Seleziona o deseleziona
 * @param {Array<Object>} props.piano - Il piano della campagna (dove gira cosa)
 * @param {boolean} props.mostraDove - Se il piano è pronto per dire dove gira ogni scenario
 */
export const GruppoScenari = ({
  nome,
  scenari,
  selezionati,
  ricerca,
  onCommuta,
  piano,
  mostraDove
}) => {
  const ids = scenari.map((s) => s.id)
  const conteggio = conteggioGruppo(ids, selezionati)
  const [aperto, setAperto] = useState(() => gruppoApertoDiDefault(conteggio, ricerca))
  const casellaRef = useRef(null)
  const cercando = ricerca.trim().length > 0
  const tutti = conteggio.scelti === conteggio.totali
  const idCorpo = `ae-gruppo-${nome.replace(/\W+/g, '-')}`

  // Una ricerca che parte apre i gruppi con risultati; a ricerca vuota si torna a mano.
  useEffect(() => {
    if (cercando) setAperto(true)
  }, [cercando])
  useEffect(() => {
    if (casellaRef.current) casellaRef.current.indeterminate = conteggio.scelti > 0 && !tutti
  }, [conteggio.scelti, tutti])

  return (
    <div className={`ae-gruppo ${aperto ? 'is-aperto' : ''}`}>
      <div className="ae-gruppo__testa">
        <button
          type="button"
          className="ae-gruppo__apri"
          aria-expanded={aperto}
          aria-controls={idCorpo}
          onClick={() => setAperto((a) => !a)}
        >
          <Icona nome={aperto ? 'pi-chevron-down' : 'pi-chevron-right'} />
          <span className="ae-gruppo__nome">{nome}</span>
          <span className={`ae-gruppo__conteggio ${conteggio.scelti ? 'is-attivo' : ''}`}>
            {conteggio.scelti}/{conteggio.totali}
          </span>
        </button>
        <input
          ref={casellaRef}
          type="checkbox"
          className="ae-voce__scelta"
          aria-label={nome}
          checked={tutti && conteggio.totali > 0}
          onChange={(e) => onCommuta(ids, e.target.checked)}
        />
      </div>
      {aperto ? (
        <div id={idCorpo} className="ae-gruppo__corpo">
          {scenari.map((sc) => (
            <VoceScenario
              key={sc.id}
              scenario={sc}
              scelto={selezionati.includes(sc.id)}
              onChange={(acceso) => onCommuta([sc.id], acceso)}
              giraSu={mostraDove ? environmentDelloScenario(sc.id, piano) : null}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}
